'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from '@/hooks/use-media-query';
interface BackgroundVideoProps {
  src: string;
  className?: string;
}
export default function BackgroundVideo(t0) {
  const $ = _c(10);
  const {
    src,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const videoRef = useRef(null);
  const [loaded, setLoaded] = useState(false);
  const shouldRenderVideo = useMediaQuery("(min-width: 1024px)");
  let t2;
  let t3;
  if ($[0] !== shouldRenderVideo) {
    t2 = () => {
      if (!shouldRenderVideo) {
        setLoaded(false);
        return;
      }
      const vid = videoRef.current;
      if (!vid) {
        return;
      }
      vid.muted = true;
      vid.autoplay = true;
      vid.playsInline = true;
      const handleCanPlay = () => setLoaded(true);
      vid.addEventListener("canplay", handleCanPlay);
      vid.load();
      return () => {
        vid.removeEventListener("canplay", handleCanPlay);
      };
    };
    t3 = [shouldRenderVideo];
    $[0] = shouldRenderVideo;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  const t4 = `relative size-full overflow-hidden rounded-3xl ${className}`;
  let t5;
  if ($[3] !== loaded || $[4] !== shouldRenderVideo || $[5] !== src) {
    t5 = shouldRenderVideo ? <video ref={videoRef} className={`absolute inset-0 size-full object-cover transition-opacity duration-700 rounded-3xl ${loaded ? "opacity-100" : "opacity-0"}`} loop={true} muted={true} playsInline={true}><source src={src} type="video/webm" /></video> : null;
    $[3] = loaded;
    $[4] = shouldRenderVideo;
    $[5] = src;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t4 || $[8] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}